import React from 'react';
import Button from 'components/Button/Button';
import RadioInput from 'components/Inputs/RadioInput/RadioInput';
import TextBoxInput from 'components/Inputs/TextBoxInput/TextBoxInput';
import useValidator from 'hooks/useValidator';
import { Patient } from 'types/types';

type FormProps = {
  patient: Patient;
  type: string;
  onSubmitReferral: (payload: Record<string, string>) => void;
};

function CareReferralForm({ patient, type, onSubmitReferral }: FormProps) {
  const [validator, showValidationMessage] = useValidator({});
  const [kindOfAppointment, setKindOfAppointment] = React.useState('');
  const [referralNotes, setReferralNotes] = React.useState('');

  const handleSubmit = async () => {
    if (!validator.allValid()) {
      showValidationMessage(true);
      return;
    }

    const payload = { type, kindOfAppointment, notes: referralNotes };

    onSubmitReferral(payload);
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-sm leading-8 mb-2">
          {`What kind of appointment does ${patient.firstName} need?`}
        </h3>
        <div className="flex flex-col space-y-4 w-full">
          <label
            htmlFor="urgentCare"
            className="cursor-pointer checkbox-form-input transition-all linear h-fit !py-[0.47rem"
          >
            <RadioInput
              id="urgentCare"
              name="kindOfAppointment"
              value="Retail Clinic or Urgent care"
              checked={kindOfAppointment === 'Retail Clinic or Urgent care'}
              onChange={() => setKindOfAppointment('Retail Clinic or Urgent care')}
              className="align-middle cursor-pointer"
            />{' '}
            <span className="align-middle text-sm ml-2 font-normal">
              Retail Clinic or Urgent care
            </span>
          </label>
          <label
            htmlFor="primaryCare"
            className="cursor-pointer checkbox-form-input transition-all linear h-fit !py-[0.47rem"
          >
            <RadioInput
              id="primaryCare"
              name="kindOfAppointment"
              value="Primary Care Provider"
              checked={kindOfAppointment === 'Primary Care Provider'}
              onChange={() => setKindOfAppointment('Primary Care Provider')}
              className="align-middle cursor-pointer"
            />{' '}
            <span className="align-middle text-sm ml-2 font-normal">Primary Care Provider</span>
          </label>
        </div>

        {validator.message(
          'kindOfAppointment',
          kindOfAppointment,
          'required|in:Primary Care Provider,Retail Clinic or Urgent care',
          {
            messages: {
              required: 'Please select an option.',
            },
            className: 'text-river-red text-[13px] mt-1  ml-1',
          },
        )}
      </div>

      <div>
        <h3 className="text-sm leading-8 mb-2">Add your referral notes or comments here:</h3>
        <TextBoxInput
          name="referralNotes"
          placeholder="Type your response here..."
          value={referralNotes}
          onChange={event => setReferralNotes(event.target.value)}
          rows={5}
          className="peer-[.validator-error]/referralNotes:!border-river-red peer-[.validator-error]/referralNotes:!mb-5 
          peer-[.validator-error]/referralNotes:focus:!ring-river-red"
          validator={validator.message('referralNotes', referralNotes, 'required|string|min:2', {
            messages: {
              required: 'Please add a referral notes or comments.',
            },
            className: 'peer/referralNotes validator-error mt-3 top-[150px] ml-1',
          })}
        />
      </div>

      <div className="!mt-20 text-center">
        <Button label="Submit" onClick={() => handleSubmit()} className="!px-2 !min-w-[250px]" />
      </div>
    </div>
  );
}

export default CareReferralForm;
